<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative mb-20 md:mb-0 ">
    <Pagesubtitle subTitle="Connect software you already use to Feedback Link and send review/feedback requests automatically."/>
    <div v-if="disabled" class="text-center">
      <div class="inline-block w-100 my-20">
        <img class="mx-auto w-32" src="@/assets/images/misc/automate.png"/>
        <p class="my-8 font-medium text-lg" > {{ disabledMessage }}</p>
        <vs-button v-if="$store.getters['dash/subscription'].isTrial" class="w-full" @click="chatToUs">Talk to us</vs-button>
        <vs-button v-else class="w-full" @click="$router.push('/dash/settings/plan')">See Plans</vs-button>
      </div>
    </div>
    <div v-else>
        <h2 class="text-center my-10">Automate review/feedback requests</h2>
        <div class="vx-row justify-center">
          <div class="vx-col w-full lg:w-1/2 mb-base flex cursor-pointer">
              <vx-card class="p-5 text-center" @click="() => {$router.push('/dash/getfeedback/automate/developers')}">
                <img src="@/assets/images/misc/code.png"  class="w-32 mx-auto"/>
                <h2 class="my-6">Developer API</h2>
                <p class="text-lg my-5">Automatically schedule or send requests for reviews/feedback to customers by integrating your systems manually.</p>
                <vs-divider/>
                <p class="mt-4">Targeted towards developers - programming skills required.</p>
              </vx-card>
          </div>
        </div>
    </div>
  </div>
</template>


<script>

import Savebutton from './components/ptcomponents/Savebutton.vue'
import Pagesubtitle from './components/ptcomponents/Pagesubtitle.vue'

export default {
  data () {
    return {
      setupData: false
    }
  },
  computed: {
    disabled () {

      if (this.$store.getters['dash/agency']) return false

      let allowAutomationOverride = typeof this.$store.state.dash.viewData.business.allowAutomation !== 'undefined' ? this.$store.state.dash.viewData.business.allowAutomation : false
      if (allowAutomationOverride) return false
      if (this.$store.getters['dash/subscription'].isTrial) return true
      return this.$store.getters['dash/subscription'].plan === '1m' || this.$store.getters['dash/subscription'].plan === '1y'
    },
    disabledMessage () {
      if (!this.disabled) return false
      if (this.$store.getters['dash/subscription'].isTrial) {
        return 'Due to risk of abuse, we\'ve disabled automation during the free trial. Please reach out if you\'d like to enable it.'
      } else {
        return 'Automation isn\'t available on your current plan. If you require this feature, you\'ll need to upgrade to the "Engage" plan or higher.'
      }
    }
  },
  components: {
    Savebutton,
    Pagesubtitle
  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
